import { PLATFORMS } from '@/constants/platforms';

export const classes = {
  panel: 'flex flex-col px-[44px] pb-[34px] pt-[44px]',
  label:
    'mb-4 text-[12px] font-extrabold uppercase tracking-[0.06em] text-taupe-1 dark:text-mauve-3',
  list: 'flex flex-col gap-[13px]',
  spacer: 'flex-1',
  footer: 'mt-6 flex justify-end',
  tileCrm:
    'bg-[linear-gradient(135deg,#2e6bff,#11b3c8)] shadow-[0_11px_24px_-8px_rgba(46,107,255,0.55)]',
  tileUnison:
    'bg-[linear-gradient(135deg,#6366f1,#8b5cf6)] shadow-[0_11px_24px_-8px_rgba(99,102,241,0.55)]',
  tileInsights:
    'bg-[linear-gradient(135deg,#0f9bb0,#1cc6d4)] shadow-[0_11px_24px_-8px_rgba(15,155,176,0.55)]',
  tileSettings:
    'bg-[linear-gradient(135deg,#ff7a45,#ef4823)] shadow-[0_11px_24px_-8px_rgba(241,90,43,0.55)]',
};

export const PLATFORM_META = [
  {
    id: PLATFORMS.CRM,
    title: 'CRM',
    description: 'Leads, bookings & patient relationships',
    tileClass: classes.tileCrm,
  },
  {
    id: PLATFORMS.UNISON,
    title: 'Unison',
    description: 'Case & project collaboration',
    tileClass: classes.tileUnison,
  },
  {
    id: PLATFORMS.INSIGHTS,
    title: 'Insights',
    description: 'Analytics & reporting',
    tileClass: classes.tileInsights,
  },
  {
    id: PLATFORMS.SETTINGS,
    title: 'Account Settings',
    description: 'Team, billing & configuration',
    tileClass: classes.tileSettings,
  },
] as const;
